module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-关于盛泰banner.8a1b3a2b.png";